/**
 * Created by christiancueni on 03/08/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Action } from '@ngrx/store';

import { SchoolRole } from './roles.model';
import { type } from '../shared/util';

export const RolesActionTypes = {
  LOAD_ROLES: type("[Role] Roles load"),
  LOAD_ROLES_FAIL: type("[Role] Roles load failed"),
  LOAD_ROLES_SUCCESS: type("[Role] Roles load success"),
  ADD_ROLE: type("[Role] Add Role"),
  ADD_ROLE_FAIL: type("[Role] Add Role failed"),
  ADD_ROLE_SUCCESS: type("[Role] Add Role success"),
  UPDATE_ROLES: type("[Role] Update Roles"),
  UPDATE_ROLES_FAIL: type("[Role] Update Roles failed"),
  UPDATE_ROLES_SUCCESS: type("[Role] Update Roles success"),
  RESET_ROLES: type('[Role] Reset')
};

export class LoadRolesAction implements Action {
    type = RolesActionTypes.LOAD_ROLES;

    constructor() {}
}

export class LoadRolesFailAction implements Action {
    type = RolesActionTypes.LOAD_ROLES_FAIL;

    constructor(public payload: string) {}
}

export class LoadRolesSuccessAction implements Action {
    type = RolesActionTypes.LOAD_ROLES_SUCCESS;

    constructor(public payload: SchoolRole[]) {}
}

export class AddRoleAction implements Action {
    type = RolesActionTypes.ADD_ROLE;

    constructor(public payload: SchoolRole) {}
}

export class AddRoleActionFailAction implements Action {
    type = RolesActionTypes.ADD_ROLE_FAIL;

    constructor(public payload: string) {}
}

export class AddRoleActionSuccessAction implements Action {
    type = RolesActionTypes.ADD_ROLE_SUCCESS;

    constructor(public payload: SchoolRole[]) {}
}

export class UpdateRolesAction implements Action {
    type = RolesActionTypes.UPDATE_ROLES;

    constructor(public payload: SchoolRole) {}
}

export class UpdateRolesActionFailAction implements Action {
    type = RolesActionTypes.UPDATE_ROLES_FAIL;

    constructor(public payload: string) {}
}

export class UpdateRolesActionSuccessAction implements Action {
    type = RolesActionTypes.UPDATE_ROLES_SUCCESS;

    constructor(public payload: SchoolRole[]) {}
}

export class ResetRolesAction implements Action {
    type = RolesActionTypes.RESET_ROLES;

    constructor() {}
}

export type RolesActions =
    LoadRolesAction
    | LoadRolesFailAction
    | LoadRolesSuccessAction
    | AddRoleAction
    | AddRoleActionSuccessAction
    | AddRoleActionFailAction
    | UpdateRolesAction
    | UpdateRolesActionSuccessAction
    | UpdateRolesActionFailAction
    | ResetRolesAction;
